var map = {
	"../shared-modules/library/library.module": [
		"../../../../../src/app/layout/shared-modules/library/library.module.ts",
		"library.module",
		"common"
	],
	"./alumni/alumni.module": [
		"../../../../../src/app/layout/alumni/alumni.module.ts",
		"alumni.module",
		"common"
	],
	"./auth-modules/login/login.module": [
		"../../../../../src/app/auth-modules/login/login.module.ts",
		"login.module"
	],
	"./auth-modules/reset-password/reset-password.module": [
		"../../../../../src/app/auth-modules/reset-password/reset-password.module.ts",
		"reset-password.module"
	],
	"./inbox/inbox.module": [
		"../../../../../src/app/layout/alumni/inbox/inbox.module.ts",
		"inbox.module",
		"common"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"layout.module"
	],
	"./photo-gallery/photo-gallery.module": [
		"../../../../../src/app/layout/alumni/photo-gallery/photo-gallery.module.ts",
		"common",
		"photo-gallery.module"
	],
	"./search/search.module": [
		"../../../../../src/app/layout/alumni/search/search.module.ts",
		"common",
		"search.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main